import { VStack, Text, Img, HStack, Button } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import { primary } from 'theme/globalStyles'
import SvgIcon from 'components/SvgIcon'
import { ITheme } from 'interfaces/theme'
import routes from 'routes'
import EmptyResultPhoto from '../../../../../assets/images/empty-result.png'

const EmptyResult = () => {
  const { organizationStore } = useStores()
  const { organization } = organizationStore
  const currentTheme: ITheme = organization?.theme ?? {}
  const navigate = useNavigate()

  return (
    <VStack spacing={4} maxWidth="374px" justifyContent="flex-start">
      <Img boxSize="250px" src={EmptyResultPhoto} alt="empty-result" />
      <VStack spacing={4}>
        <Text color="gray.700" fontSize="20px" fontWeight="600" lineHeight="28px">
          Oops! No result.
        </Text>
        <Text color="gray.700" fontSize="16px" fontWeight="500" lineHeight="24px" textAlign="center">
          We can’t find any item that match your criteria. Please try searching for something else
        </Text>
        <HStack>
          <Text color="gray.700" fontSize="16px" fontWeight="500" lineHeight="24px">
            Or maybe you could find them here
          </Text>
          <Button
            height="32px"
            border="0"
            color="white"
            fontSize="14px"
            fontWeight={500}
            lineHeight={5}
            _hover={{ opacity: 0.8 }}
            background={currentTheme?.primaryColor ?? primary}
            leftIcon={<SvgIcon iconName="archive" size={14} color="white" />}
            onClick={() => navigate(routes.archive.value)}
          >
            Archive
          </Button>
        </HStack>
      </VStack>
    </VStack>
  )
}

export default observer(EmptyResult)
